/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2022, 2024
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import axios, { ResponseType } from 'axios';

import { StoreQueryParams } from '../../../../ts';
import { ImageUploadPreference } from '../../../../ts/preferences';
import { endpoints } from '../../util/config';

const auditParams: StoreQueryParams = {
  include_audit: true,
  verbose: true
};

/**
 * Fetch the screenshot of a given URL
 */
export const screenshot = async (url: string): Promise<Buffer> => {
  const conType = url.startsWith(ImageUploadPreference.UPLOAD_PNG_PREFIX)
    ? 'image/png'
    : 'image/jpeg';
  const response = await axios.get(`${endpoints.store}/preview/screenshot`, {
    params: {
      ...auditParams,
      url
    },
    headers: {
      'content-type': conType
    },
    responseType: 'arraybuffer'
  });
  return response.data;
};

export const imageUpload = async (
  imageId: string,
  targetFile: File
): Promise<Buffer> => {
  const url = `${endpoints.store}/preview/upload`;
  const config = {
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    responseType: 'arraybuffer' as ResponseType
  };
  const formData = new FormData();
  formData.append('imageid', imageId);
  formData.append('target-image', targetFile);
  const response = await axios.post(url, formData, config);

  return response.data;
};
